import React from "react";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import { I18n } from "@aws-amplify/core";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import CustomSignIn from "./CustomSignIn";
import CustomConfirmSignIn from "./CustomConfirmSignIn";
import PoweredBy from "../Footer/PoweredBy";
import Version from "../Version";
import images from "../../assets/img/images";

const styles = (theme) => ({
  authContainer: {
    padding: "0px 12px",
    maxWidth: "400px",
    margin: "auto",
  },
  gridContainer: {
    minHeight: "100vh",
  },
  logoContainer: {
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      margin: "30px 0px",
    },
    [theme.breakpoints.up("md")]: {
      margin: "100px 0px 60px",
    },
  },
  logo: {
    [theme.breakpoints.down("md")]: {
      "& img": {
        width: "300px",
      },
      margin: "0px auto 5px",
    },
    [theme.breakpoints.up("md")]: {
      "& img": {
        width: "300px",
      },
      margin: "0px auto 20px",
    },
  },
});


const Authentication = (props) => {
  const [resent, setResent] = React.useState(false);
  const [authState, setAuthState] = React.useState("signIn");
  const [username, setUsername] = React.useState("");

  const handleAuthStateChange = (state, data) => {
    if (state === "confirmSignIn") {
      setAuthState("confirmSignIn");

      if (data && data.username) {
        setUsername(data.username);
      }
    } else if (state === "signIn") {
      setAuthState("signIn");
      props.handleAuthChange?.("signIn");
    } else if (state === "signedIn") {
      props.handleAuthChange?.("signedIn");
    }
  };

  const handleClose = () => setResent(false);

  return (
    <Grid
      container
      direction="column"
      alignItems="stretch"
      className={props.classes.gridContainer}
    >
      <Dialog
        open={resent}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        style={{ padding: "25px" }}
      >
        <DialogContent style={{ padding: "25px" }}>
          <DialogContentText style={{ fontWeight: "bold" }}>
            {I18n.get("resent")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus style={{ position: "relative", right: "200px" }}>
            {I18n.get("site_close")}
          </Button>
        </DialogActions>
      </Dialog>
      <Grid item className={props.classes.logoContainer}>
        <Box className={props.classes.logo}>
          <img src={images.lukeLogoLogin} alt="luke_logo" />
        </Box>
        <Version />
      </Grid>
      <Grid item xs className={props.classes.authContainer}>
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <>
              {authState === "signIn" && (
                <CustomSignIn onAuthStateChange={handleAuthStateChange} />
              )}
              {authState === "confirmSignIn" && (
                <CustomConfirmSignIn
                  onAuthStateChange={handleAuthStateChange}
                  username={username}
                />
              )}
            </>
          </Grid>
        </Grid>
      </Grid>
      <PoweredBy />
    </Grid>
  );
};

export default withStyles(styles)(Authentication);
